import styled from 'styled-components'
import { Breakpoints } from 'Pages/landings/common/styles'

export const Wrapper = styled.div`
	background: #202227;
	box-shadow: 0px 4px 6px -2px #22253908, 0px 12px 16px -4px #22253914;
	border-radius: 10px;
	padding: 16px;
	display: flex;
	position: fixed;
	left: 10px;
	right: 10px;
	bottom: 10px;
	min-height: 92px;
	max-width: 920px;
	flex-direction: column;
	margin: 0px auto 0px auto;
	z-index: 2000;
	box-sizing: border-box;
	@media (min-width: ${Breakpoints.md}) {
		align-items: center;
		flex-direction: row;
		left: 40px;
		right: 40px;
		bottom: 40px;
	}
`

export const Text = styled.p`
	color: #e3e3e7;
	font-size: 14px;
	line-height: 20px;
	margin: 0px 0px 16px 0px;
	font-family: SBSansText, 'Open Sans', sans-serif;
	@media (min-width: ${Breakpoints.md}) {
		margin: 0px 16px 0px 0px !important;
	}
`

export const TextLink = styled.span`
	cursor: pointer;
	color: #21ba72;
	font-family: SBSansText, 'Open Sans', sans-serif;
`

export const Button = styled.button`
	background: #21ba72;
	color: #ffffff;
	font-family: SBSansInterface, 'Open Sans', sans-serif;
	width: 90px;
	height: 40px;
	font-size: 14px;
	line-height: 16px;
	padding: 12px 16px;
	border: none;
	box-sizing: border-box;
	border-radius: 6px;
	cursor: pointer;
`
